import React from 'react';
import './assets/css/index.css';
import { CacheManager, LzEncryptor, Utils } from './utils';
import ReactDOM from 'react-dom/client';
import { getTemplateComponent } from './templates/registrar';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Debugger, NoseurObject, Position, StringHelper, Toaster } from '@rivtn/noseur';
import { BaseService, IHostWebsite, IProfileWebsite, IProgram, ITeamWebsite, ITournament, ITournamentEditionWebsite, OmneHostService, SanitizedResponse } from './services';

interface Renderer {
    path: string;
    publicId: string;
    params: NoseurObject<any>;
}

Debugger.setNamespace("OMNEHOST.USER_LANDS");
const omnehostService = OmneHostService.getInstance();
const paths = StringHelper.segmentSplit(window.location.pathname, '/');

const searchParams = new URLSearchParams(window.location.search);

if (searchParams.has("pas")) {
    const pas = JSON.parse(LzEncryptor.decrypt(searchParams.get("pas"), true)) as any;
    Debugger.log("Index:useEffect:pas", searchParams.get("pas"), "\n=>\n", pas);
    CacheManager.put(CacheManager.ACCESS_TOKEN_KEY, pas.a);
    searchParams.delete("pas");
    CacheManager.put(CacheManager.SESSION_TOKEN_KEY, pas.s);
    window.history.pushState({}, document.title, window.location.pathname + (!!searchParams.size ? `?${searchParams.toString()}` : ""));
    omnehostService.getMember(pas.p.external_id).then(({ sanitized }: any) => {
        CacheManager.put(CacheManager.PROFILE_KEY, { ...pas.p, ...sanitized, janus_user_external_id: pas.p.external_id });
        proceedRenderLogic();
    }).catch(BaseService.reportError);
} else {
    proceedRenderLogic();
}

function proceedRenderLogic() {
    Debugger.log("INDEX", "extracted pathname parts", paths);
    if (paths.length < 2) {
        window.location.replace(process.env.REACT_APP_OMNEHOST_DASHBOARD_URL!);
    } else {
        let [path, publicId] = paths; path = path.toLowerCase();
        omnehostService.performHandShake().then(() => {
            const query: any = {};
            if (searchParams.has("edi")) query.edition = searchParams.get("edi");
            omnehostService.getMethod(path)(publicId, query).then(({ sanitized }: SanitizedResponse<IProgram | IProfileWebsite | ITeamWebsite | IHostWebsite | ITournamentEditionWebsite>) => {
                let renderer: Renderer;
                if (!!(sanitized as any).design_settings) {
                    let designId = (sanitized as any).design_settings.design_id;
                    if (window.location.search?.includes("pp")) {
                        const previewPayload = JSON.parse(LzEncryptor.decrypt(new URLSearchParams(window.location.search).get("pp"), true));
                        // TODO validate if they can using quick key validation in omnehost-userheavens
                        designId = previewPayload.id;
                    }
                    const component = getTemplateComponent(path, designId);
                    renderer = {
                        publicId,
                        path: `./templates/${component.default.path}`,
                        params: {
                            website: sanitized
                        }
                    };
                } else {
                    // else to an ad page
                    renderer = {
                        publicId,
                        path: `./templates/program/components/Landing`,
                        params: {
                            program: sanitized
                        }
                    };
                }
                render(renderer);
            }).catch(async (err: any) => {
                BaseService.reportError(err);
                // if no program found popup and ask then redirect to create support ticket to request the program fill some of the informations
                // if path is member, team or host redirect to dashboard
                // if path is tournament redirects to tournament listing page
            });
        }).catch(async (err: any) => {
            BaseService.reportError(err);
            // TODO redirect to raise ticket page as we offline
        });
    }
}

function render(renderer: Renderer) {
    const basePath = `${paths[0]}/${paths[1]}`;
    Debugger.log("INDEX", "the loaded website settings", renderer);
    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
        //<React.StrictMode>
        <RouterProvider router={createBrowserRouter([
            {
                path: `${basePath}/*`, element:
                    React.createElement(require("" + renderer.path).default, {
                        basePath,
                        publicId: renderer.publicId,
                        ...renderer.params,
                    })
            },
        ])} />
        //</React.StrictMode>
    );
    Toaster.init({ position: Position.TOP_CENTER });
}

